<template>
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="loading" class="loading-pagination">
      <SpinnerColor />
    </div>
    <vs-table ref="table" multiple v-model="selected" noDataText="" :max-items="missionData.itemsPerPage" :data="data">
        <div slot="header" class="flex flex-wrap items-center flex-grow">
          <div class="flex flex-wrap-reverse justify-between items-center data-list-btn-container w-full" style="position: relative;">
            <!-- TITLE TABLE -->
            <div>
              <feather-icon icon="PackageIcon" svgClasses="h-4 w-4"></feather-icon>
              <h3 class="font-semibold ml-3" style="display: inline-block; font-size: 1.125rem;">{{ $t('missions') }}</h3>
            </div>
            <div style="position: relative; width: 38%">
              <input v-model="search" @input="checkAdvanceSearch()" @keyup.enter="advancedSeachMission()" placeholder="ابحث هنا بالكود" class="search-mission w-full" />
              <i class="icon-advanced-search" @click="advancedSeachMission()">
                <p v-if="errSearch" class="err-search">برجاء ادخال كود المهمة اولاً</p>
                <vx-tooltip text="إضغط للبحث" delay="0.2s" position="bottom">
                <svg xmlns="http://www.w3.org/2000/svg" width="16.414" height="16.653" viewBox="0 0 16.414 16.653">
                  <g id="search" transform="translate(1 1)">
                    <circle id="Ellipse_274" data-name="Ellipse 274" cx="6" cy="6" r="6" fill="none" stroke="#6e6b7b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <line id="Line_69" data-name="Line 69" x1="3.469" y1="3.469" transform="translate(10.531 10.77)" fill="none" stroke="#6e6b7b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </g>
                </svg>
                </vx-tooltip>
              </i>
              <span style="position: absolute;right: 0;top: 75%;color: red;font-size: 12px;" v-if="errSearchMsg">{{errSearchMsg}}</span>
            </div>
          </div>
        </div>
        
      <template slot="thead">
        <vs-th :key="index" v-for="(head, index) in header" :sort-key="head.key">{{ $t(head.head) }}</vs-th>
      </template>
          <!-- MISSIONS -->
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in allMissions">
            <vs-td :key="index" v-for="(td, index) in body" >
              <p v-if="td == 'code'" @click.stop="toMissionDetails(tr.id)" class="product-due_date font-medium truncate code">{{ tr[td] }}</p>
              <p v-else class="product-due_date font-medium truncate">{{ missionTypeAndStatus(tr, td) }}</p>
              <p @click.stop=""  v-if="tr[td] == null">
                <vs-chip class="product-sender" style="font-size: 0.5625rem;" >لا يوجد</vs-chip>
              </p>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon v-if="tr.status == 1" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="popupActiveMethod(tr.id)" />
              <vx-tooltip v-else :text="`لا يمكن حذف مهمة حالتها : ${reasonNotDelete(tr.status)}`" position="right" delay=".1s">
                <i style="opacity: 0.6; cursor: no-drop;">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 stroke-current" class="ml-2"/>
                </i>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </tbody>
        <!-- Popup Confirmation -->
        <vs-popup class="holamundo"  :title="$t('areYouDelete')" :active.sync="popupActive" @close="triggerClose" ref="popupcontent">
          <div class="mb-4" v-if="!loadReasons">
          <div class="my-select">
          <label class="font-bold mb-1">{{ $t('ChooseReasonCancellation') }} </label> :
          <vs-input
            name="government"
            maxlength="250"
            v-model="cancelationReason"
            class="w-full"
          />
        </div>
              
            <p class="text-danger font-bold" style="font-size: 10px;">{{ errCancelMission }}</p>
            <p class="text-danger font-bold" style="font-size: 10px;" v-if="err_mission_cancel_reasons">{{ err_mission_cancel_reasons }}</p>
          </div>
          <div class="my-4" v-else>
            <SpinnerColor />
          </div>
          <vs-button @click.stop="deleteData()" color="danger" class="mr-3" type="filled">{{ $t('accept') }}</vs-button>
          <vs-button @click="popupActive=false" color="primary" type="filled">{{ $t('cancel') }}</vs-button>
        </vs-popup>
    </vs-table>
    <!-- Loading Search -_- -->
    <div class="p-6 loading-table" v-if="loadAdvanceMission">
      <SpinnerColor />
    </div>

    <div v-if="hasData && !checkSearch" class="flex justify-between items-center px-6 responsive-footer">
      <!-- ITEMS PER PAGE -->
      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
        <div style="font-family: 'Cairo', sans-serif !important; padding: 0.75rem !important; border-radius: 0.25rem !important;" class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
          <span class="mr-2">{{ currentPage }} - {{ missionData.itemsPerPage * missionData.pageNum }} {{ $t('of') }} {{ feed_count_missions }}</span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <vs-dropdown-menu>
          <ul style="min-width: 8rem">
            <vs-dropdown-item @click="missionData.itemsPerPage=10"  class="m-0 p-0">
              <li
                class="flex py-4 px-4 cursor-pointer profile-drop">
                <span>10</span>
              </li>
            </vs-dropdown-item>
            <vs-divider class="m-0" />
            <vs-dropdown-item @click="missionData.itemsPerPage=20"  class="m-0 p-0">
              <li
                class="flex py-4 px-4 cursor-pointer profile-drop">
                <span>20</span>
              </li>
            </vs-dropdown-item>
            <vs-divider class="m-0" />
            <vs-dropdown-item @click="missionData.itemsPerPage=50"  class="m-0 p-0">
              <li
                class="flex py-4 px-4 cursor-pointer profile-drop">
                <span>50</span>
              </li>
            </vs-dropdown-item>
            <vs-divider class="m-0" />
            <vs-dropdown-item @click="missionData.itemsPerPage=100"  class="m-0 p-0">
              <li
                class="flex py-4 px-4 cursor-pointer profile-drop">
                <span>100</span>
              </li>
            </vs-dropdown-item>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
      <div>
        <vs-pagination
          :total="totalPage"
          v-model="missionData.pageNum"
          :prev-icon="$vs.rtl ? 'arrow_forward' : 'arrow_back'"
          :next-icon="$vs.rtl ? 'arrow_back' : 'arrow_forward'" 
        />
      </div>
    </div>
    <empty-data v-else-if="!hasData" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"
import EmptyData from './EmptyData.vue'
import SpinnerColor from './SpinnerColor2.vue'
import globalMixin from '@/mixins/mixins.js'
import emptyTable from '@/mixins/datatableEmpty.js'
import helper from '@/mixins/helper.js'
import notify from '@/mixins/notifyState.js'
import SelectInputVue from "@/layouts/components/SelectInput.vue"

export default {
  name: 'data-table-mission',
  mixins: [globalMixin, emptyTable, helper, notify],
  components: {
    SpinnerColor,
    EmptyData,
    SelectInputVue
  },
  props: {
    data: {
      type: Array,
    },
    header: {
      type: Array,
      required: true
    },
    body: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selected: [],
      checkSelect: false,
      isMounted: false,
      popupActive: false,
      id: '',
      missionData: {
        pageNum: 1,
        itemsPerPage: 10,
      },
      search: '',
      reasonOfCantDelete: '',
      checkSearch: false,
      loadAdvanceMission: false,
      errSearch: false,
      errSearchMsg: false,
      loading: false,
      loadReasons: false,
      cancelationReason: '',
      errCancelMission: '',
    }
  },
  computed: {
    ...mapGetters('dataList', ['missions', 'feed_count_missions', 'search_mission', 'max_mission_updated_at', 'message', 'mission_canelation_reasons', 'err_mission_cancel_reasons']),
    ...mapState('dataList', ['next_page_url_cancelation_reasons']),
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length
    },
    totalPage (){
      return Math.ceil(this.feed_count_missions / this.missionData.itemsPerPage)
    },
    allMissions() {
      if(this.hasData && !this.checkSearch && !this.loadAdvanceMission) {
        return this.data
      }else if (this.hasData && this.search != '' && this.checkSearch && !this.loadAdvanceMission) {
        return this.search_mission
      }
    },
  },
  watch: {
    'missionData.pageNum': {
      handler() {
        this.updtaeMissions()
      },
      deep: true
    },
    'missionData.itemsPerPage': {
      handler() {
        this.updtaeMissions()
      },
      deep: true
    },
    missions: {
      handler: function() {
        this.tableHasData(this.missions)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('dataList', ["deleteMission", "fetchDataMissions", "searchMission", "cancelMissionReasons"]),
    async advancedSeachMission(){
      if(this.search){
        this.loadAdvanceMission = true
        this.missionData.code = this.search
        await this.searchMission(this.missionData)
        if (this.message) {
          this.errSearchMsg = this.message
        }else {
          this.errSearchMsg = ''
        }
        this.loadAdvanceMission = false
        this.checkSearch = true
        this.errSearch = false
      } else {
        this.errSearch = true
        return false
      }
    },
    async deleteData () {
      if(this.cancelationReason) {
        this.errCancelMission = ""
        if(this.checkSelect == true){
          let myId = ''
          this.selected.forEach(element => {
            myId += element.id+'|'
          });
          await this.deleteMission({id: myId, reason: this.cancelationReason})
          this.selected = []
          this.popupActive = false
        }else{
          await this.deleteMission({id: this.id, reason: this.cancelationReason})
          // this.fetchDataMissions(this.missionData)
          this.popupActive = false
        }
        if(this.$store.state.dataList.successApi == 1){
          this.notifySuccess("success");
        }else{
          this.notifyFaild("faild");
        }
      }else {
        this.errCancelMission = "يجب اختيار السبب"
      }
    },
    triggerClose () {
      this.$refs.popupcontent.$el.children[1].children[1].scrollTop = 0
    },
    async popupActiveMethod (id, type){
      this.popupActive = true;
      this.loadReasons = true;
        this.checkSelect = false
        this.id = id;
      this.loadReasons = false;
    },
    toMissionDetails(id){
      this.$router.push({ path: `/MissionDetails/${id}` })
    },
    reasonNotDelete (status) {
      if(status == 2){
        return 'جديدة'
      }else if (status == 3){
        return 'معينة للمندوب'
      }else if (status == 4){
        return 'عند المندوب'
      }else if (status == 5){
        return 'منفذة'
      }else if (status == 6){
        return 'ملغاة'
      }else if (status == 7){
        return 'منفذة مع المندوب'
      }else{
        return 'ملغاة مع المندوب'
      }
    },
    async checkAdvanceSearch(){
      this.checkSearch = false
    },
    missionTypeAndStatus(tr, td) {
      if (td == "type") {
        if (tr.type == 1) return this.$t('receive');
        else if (tr.type == 2) return this.$t('supply2');
        else if (tr.type == 3) return this.$t('receivingAndSupplying');
        else return this.$t('returnsOrReceiptsAndReturns');
      } else if (td == "status") {
        if (tr.status == 1) return "مرسلة";
        else if (tr.status == 2) return "جديدة";
        else if (tr.status == 3) return "معينة للمندوب";
        else if (tr.status == 4) return "عند المندوب";
        else if (tr.status == 5) return "منفذة";
        else if (tr.status == 6) return "ملغاة";
        else if (tr.status == 7) return "منفذة مع المندوب";
        else if (tr.status == 8) return "ملغاة مع المندوب";
      } else {
        return tr[td];
      }
    },
    async updtaeMissions() {
      this.loading = true
      if(this.search == ''){
        await this.fetchDataMissions(this.missionData)
      }else{
        this.missionData.code = this.search
        await this.searchMission(this.missionData)
      }
      this.loading = false
    },
    async infiniteHandler($state) {
      if (!this.next_page_url_cancelation_reasons) {
        $state.complete();
      } else {
        await this.cancelMissionReasons(true);
        $state.loaded();
      }
    }
  },
  mounted () {
    this.isMounted = true
  },
}
</script>


<style lang="scss">
@import '@/assets/scss/vuexy/_dataTable.scss';
.con-vs-popup .vs-popup {
  max-height: 450px;
  .custom-select {
    display: block;
    height: auto;
    .selected {
      min-height: 37px;
    }
    .items {
      position: unset;
    }
  }
}
.vs-popup--content {
  max-height: 450px;
  height: 100%;
}
</style>
<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_loadingTable.scss';
.search-mission{
  width: 38%;
  height: 38px;
  border: 1px solid #D8D6DE;
  border-radius: 4px;
  padding: 0 0.75rem;
  color: #212121;
  margin-top: 15px;
  margin-bottom: 15px;
}
.icon-advanced-search{
  position: absolute;
  right: 10px;
  top: 25px;
  cursor: pointer;
}
.err-search {
  position: absolute;
  right: 310px;
  bottom: -21px;
  z-index: 999;
  min-width: 200px;
  color: red;
  font-size: 12px;
}
</style>